import { AuthenticationRepository } from './../../../../../../core/data/repository/authentication-repository';
import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { StatisticsFilterForm } from 'src/app/shared/interfaces';
import { DateFormatterPipe } from 'src/app/shared/pipes';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-pdf-top-header',
  standalone: true,
  imports: [CommonModule, MatIconModule, TranslateModule, DateFormatterPipe , AngularSvgIconModule],
  templateUrl: './pdf-top-header.component.html',
  styleUrls: ['./pdf-top-header.component.scss'],
})
export class PdfTopHeaderComponent implements OnInit {
  @Input() filter: StatisticsFilterForm;
  logo : string;
  constructor(private authenticationRepository: AuthenticationRepository, private sanitizer: DomSanitizer) {
    this.logo = this.authenticationRepository.currentUser$.value.whiteLabelDashboardLogoURL ;
  }


  ngOnInit(): void {}



}
